import { apiClient } from './client';
import { MotoboyHistorico, MotoboyLocalizacao, PainelMotoboyData } from '../types';

export function listarMotoboysRastreamento(): Promise<MotoboyLocalizacao[]> {
  return apiClient.get('/rastreamento/motoboys').then((res) => res.data.motoboys);
}

export function listarHistoricoMotoboys(ids?: number[]): Promise<MotoboyHistorico[]> {
  const query = ids?.length ? `?motoboy_ids=${ids.join(',')}` : '';
  return apiClient.get(`/rastreamento/motoboys/historico${query}`).then((res) => res.data.historico);
}

export function buscarPainelMotoboy(tenantId: number, token: string): Promise<PainelMotoboyData> {
  return apiClient.get(`/publico/motoboys/${tenantId}/${token}`).then((res) => res.data);
}

export function loginMotoboy(
  tenantId: number,
  celular: string,
  senha: string
): Promise<{ motoboy: PainelMotoboyData['motoboy']; token_rastreamento: string }> {
  return apiClient.post(`/publico/motoboys/${tenantId}/login`, { celular, senha }).then((res) => res.data);
}

export function enviarLocalizacaoMotoboy(
  tenantId: number,
  token: string,
  payload: {
    latitude: number;
    longitude: number;
    precisao_metros?: number | null;
    pedido_id?: number | null;
  }
): Promise<{ ok: boolean }> {
  return apiClient.post(`/publico/motoboys/${tenantId}/${token}/localizacao`, payload).then((res) => res.data);
}
